import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'modify_confirmation';
export const route = 'modify_confirmation/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "modify_confirmation" */
/* webpackPrefetch: true */
'../components/ConfirmationPage')));